import SideNavBar from '../components/SideNavBar/SideNavBar';
import {
  UseNavBar,
  UseNavigation,
  UseUser,
  UseSignIn,
} from 'lb-store/src/hooks';
import cls from './app.mob.module.scss';
import {
  BalanceIcon,
  MenuIcon,
  PromoPorsche,
  SmallLogoIcon,
  UserIconNew,
  PlusIcon,
  EyeIconNew,
  EyeClosedIconNew,
} from '../assets/icons';
import { Button, Icon } from 'lb-components';
import BottomNavBar from '../components/BottomNavBar/BottomNavBar';
import React, { useEffect, useRef, useState } from 'react';
import UseBottomBar from 'lb-store/src/hooks/useBottomBar';
import { Api, useTranslation } from 'lb-store';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { useDimension } from 'lb-components';
import PromoTooltip from '../components/PromoTooltip/PromoTooltip';
import Moment from 'moment';
import useUser from 'lb-store/src/hooks/useUser';
import classNames from 'classnames';

const AppMob = () => {
  const { t, i18n } = useTranslation();
  const [navWidth, setNavWidth] = useState(0);
  const [bottomHeight, setBottomHeight] = useState(0);
  const { User, updateBalance, logout, keepAlive } = UseUser();
  const navbar = UseNavBar();
  const signInModal = UseSignIn();
  const bottomBar = UseBottomBar();
  const navContentRef = useRef();
  const navBackDropRef = useRef();
  const nav = UseNavigation();

  const [isLogged, setIsLogged] = useState(null);
  const [currentPromoData, setCurrentPromoData] = useState();
  const [showBalance, setShowBalance] = useState(false);

  const { clientHeight } = useDimension();
  /*useEffect(() => {
    const path = window.location.pathname.split('/');
    const index = _.includes(['ka', 'en', 'ru'], path[1]) ? 2 : 1;

    keepAlive().then((res) => {
      setIsLogged(res.status);

      if (path[index] === 'user') {
        const route = _.includes(
          [undefined, 'manage-balance', 'security-options', 'sms-notify'],
          path[index + 1]
        )
          ? 'main'
          : path[index + 1];
        if (res.status) bottomBar.Open({ route: route });
        else
          signInModal.open({
            onSuccess: () => {
              setIsLogged(true);
              bottomBar.Open({ route: route });
            },
            onCancel: () => nav.navigate('/'.concat(i18n.language)),
          });
      }
    });
  }, []);*/
  useEffect(() => {
    //window.updateBalance()
    /*if (isLogged !== null) {
      setIsLogged(!!User.isLogged);
    }*/

    //console.log('User',User)

    if (User.isLogged !== null) {
      const path = window.location.pathname.split('/');
      const index = _.includes(['ka', 'en', 'ru'], path[1]) ? 2 : 1;

      if (path[index] === 'user') {
        const route = _.includes(
          [undefined, 'manage-balance', 'security-options', 'sms-notify'],
          path[index + 1]
        )
          ? 'main'
          : path[index + 1];
        if (User.isLogged) bottomBar.Open({ route: route });
        else
          signInModal.open({
            onSuccess: () => {
              setIsLogged(true);
              bottomBar.Open({ route: route });
            },
            onCancel: () => nav.navigate('/'.concat(i18n.language)),
          });
      }
    }
    if (isLogged !== User.isLogged) setIsLogged(User.isLogged);

    /*if (User.isLogged) {
      Api.User.Promotions().then((res) => {
        if (res.status && res.data?.status === 1) {
          setCurrentPromoData(
            _.find(res.data?.data, (v, k) => {
              const [startDate, endDate] = k.split(':');
              return Moment().isBetween(Moment(startDate), Moment(endDate));
            }) || {}
          );
        }
      });
    }*/
  }, [User.isLogged]);


  return (
    <>
      <SideNavBar
        ref={{
          backdropRef: navBackDropRef,
          navContentRef: navContentRef,
        }}
        callback={setNavWidth}
      />
      {!(
        User?.data?.personalinfo_upl !== 'yes' && User?.data?.banned === 3
      ) && (
        <BottomNavBar
          nav={nav}
          navRefs={{
            backdropRef: navBackDropRef,
            navContentRef: navContentRef,
          }}
          callback={setBottomHeight}
          clientHeight={clientHeight}
        />
      )}

      <header className={cls.headerMobile}>
        <div className={cls.menu}>
          <div
            className={cls.icon}
            style={{ backgroundImage: `url(${MenuIcon})` }}
            onClick={() => navbar.Open()}
          />
          <Link
            to={'/'.concat(i18n.language)}
            className={cls.logo}
            style={{ backgroundImage: `url(${SmallLogoIcon})` }}
            onClick={(e) => {
              if (e.ctrlKey) return;
              e.preventDefault();
              nav.navigate('/'.concat(i18n.language));
            }}
          />
        </div>
        <div className={cls.signIn}>
          {/*<Icon
            Icon={PromoPorsche}
            classname={cls.currPromo}
            onClick={() =>
              nav.navigate(`/${i18n.language}/promotions/wonderland`)
            }
          />*/}
          {isLogged !== null &&
            (isLogged ? (
              <div style={{ display: 'flex' }}>
                {/*{isLogged === true && currentPromoData && (
                  <div>
                    <PromoTooltip data={currentPromoData} isMob={true} />
                  </div>
                )}*/}
                {/*<Button
                  variant='success'
                  style={{
                    display: 'flex',
                    fontSize: '2rem',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '1.2rem',
                    marginRight: '10px',
                  }}
                  onClick={() => bottomBar.Open({ route: 'deposit' })}
                >
                  <Icon Icon={BalanceIcon} width={'2rem'} height={'2rem'} />{' '}
                  &nbsp;{t('შევსება')}{' '}
                </Button>*/}
                <div
                  className={cls.balanceContainer}
                  onClick={() => {
                    updateBalance(true).then(() => {
                      if (!showBalance) {
                        window.showBalance = setTimeout(() => {
                          setShowBalance(false);
                        }, 10000);
                      } else {
                        clearTimeout(window.showBalance);
                      }
                      setShowBalance(!showBalance);
                    });
                  }}
                >
                  <div className={cls.toggleBalanceBtn}>
                    <Icon
                      Icon={showBalance ? EyeIconNew : EyeClosedIconNew}
                      width={'1.8rem'}
                      height={'1.8rem'}
                      type={'vec'}
                      style={{ backgroundColor: '#98A2B8' }}
                    />
                  </div>
                  <span
                    className={!showBalance ? cls.hide : null}
                    data-dots={'••••'}
                  >
                    {User.balance.balance} ₾
                  </span>
                  <Button
                    className={cls.depositBtn}
                    variant={'success'}
                    onClick={(e) => {
                      e.stopPropagation();
                      bottomBar.Open({ route: 'deposit' });
                    }}
                  >
                    <Icon
                      Icon={PlusIcon}
                      width={'1.6rem'}
                      height={'1.6rem'}
                      type={'vec'}
                      style={{ backgroundColor: '#2B3240' }}
                    />
                  </Button>
                </div>
                <Button
                  className={cls.userBtn}
                  variant='secondary'
                  onClick={() => bottomBar.Open({})}
                >
                  <Icon
                    Icon={UserIconNew}
                    width={'2.4rem'}
                    height={'2.4rem'}
                    type={'vec'}
                    style={{ backgroundColor: '#FFFFFF' }}
                  />
                </Button>
                {(User?.data?.person_verified === 'no' || User?.data?.banned === 3) && (
                  <Button
                    variant='danger'
                    style={{
                      display: 'flex',
                      fontSize: '2rem',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '1.2rem',
                      aspectRatio: '2',
                      marginLeft: '10px',
                    }}
                    onClick={() => logout()}
                  >
                    <span>{t('გასვლა')}</span>
                  </Button>
                )}
              </div>
            ) : (
              <Button
                style={{ fontSize: '2rem' }}
                onClick={() => {
                  if (isLogged) bottomBar.Open({});
                  else
                    signInModal.open({
                      onSuccess: () => {
                        setIsLogged(true);
                        /*updateBalance().then(() => bottomBar.Open({}));*/
                        updateBalance().finally();
                      },
                    });
                }}
              >
                {t('შესვლა')}
              </Button>
            ))}
        </div>
      </header>
    </>
  );
};

export default AppMob;
